var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createNewPage } from '@/helpers';
import { MATFILE_ENDLESS_TYPE, AUTOFILL_PATTERN } from "../../constants";
import Section from "../../entities/Section";
import { getAllLayers, getShieldSectionsArray, getGroupShieldsArray, getPageObjects, applyPageWidthToPage, copySectionToShield, clearShield } from "./common";
export var autofillPagesWithStartSection = function (pagesData, startSectionId, list, pattern, additOptions, state) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var matfile = additOptions.matfile, includeOtherContent = additOptions.includeOtherContent;
    var _r = getAllLayers(startSectionId, pagesData.store), selPage = _r.page, selGroup = _r.group, selShield = _r.shield, selSection = _r.section;
    if (selPage && selGroup && selShield && selSection) {
        pagesData.lastElement = { section: null, shield: null };
        var fillAmount = list.length;
        var selPageLength = selPage.box.r;
        var allShields_1 = [];
        var selPageIndex = selPage ? pagesData.order.findIndex(function (el) { return el === selPage.uid; }) : -1;
        var selShieldGroupIndex = Object.keys(selGroup.shields).findIndex(function (el) { return el === selShield.id; });
        var fillShields_1 = [];
        var shieldsStep = ((_b = (_a = state === null || state === void 0 ? void 0 : state.core) === null || _a === void 0 ? void 0 : _a.selWizard) === null || _b === void 0 ? void 0 : _b.application_type) === 'CABLE_FLAG' && ((_d = (_c = state === null || state === void 0 ? void 0 : state.core) === null || _c === void 0 ? void 0 : _c.selWizard) === null || _d === void 0 ? void 0 : _d.data) ? 2 : 1;
        // collect (with creating if not exist(with pages)) shields
        switch (pattern) {
            case AUTOFILL_PATTERN.NEXT_CELL: {
                //***** each next autofill value for each next shield *****
                var fillPageGroupShields = getGroupShieldsArray(selGroup);
                var shieldsInGroup = fillPageGroupShields.length;
                for (var i = 0, si = selShieldGroupIndex, pi = selPageIndex; i < fillAmount; si = si + shieldsStep, i++) {
                    var curShieldGroupIndex = si % shieldsInGroup;
                    // if handled all shields in current page - go to next page
                    if (si / shieldsInGroup >= 1 && (curShieldGroupIndex === 0 || ((_f = (_e = state === null || state === void 0 ? void 0 : state.core) === null || _e === void 0 ? void 0 : _e.selWizard) === null || _f === void 0 ? void 0 : _f.application_type) === 'CABLE_FLAG' && ((_h = (_g = state === null || state === void 0 ? void 0 : state.core) === null || _g === void 0 ? void 0 : _g.selWizard) === null || _h === void 0 ? void 0 : _h.data))) {
                        pi++;
                        var currFillPage = checkExistingPageByIndex(pi, pagesData, { pageLength: selPageLength, matfile: matfile }, state);
                        var currFillPageGroups = getPageObjects(currFillPage).groups;
                        for (var grUid in currFillPageGroups) {
                            if (currFillPageGroups[grUid].id === selGroup.id) {
                                fillPageGroupShields = getGroupShieldsArray(currFillPageGroups[grUid]);
                                break;
                            }
                        }
                    }
                    if (fillPageGroupShields && fillPageGroupShields[curShieldGroupIndex]) {
                        fillShields_1.push(fillPageGroupShields[curShieldGroupIndex]);
                    }
                    fillPageGroupShields.forEach(function (shield) {
                        allShields_1.push(shield);
                    });
                }
                break;
            }
            case AUTOFILL_PATTERN.NEXT_PAGE: {
                //***** each next autofill value for one same positioned(selShieldGroupIndex) shield of each next page *****
                for (var i = 0; i < fillAmount; i++) {
                    var currFillPage = checkExistingPageByIndex(selPageIndex + i, pagesData, { pageLength: selPageLength, matfile: matfile }, state);
                    var currFillPageGroups = getPageObjects(currFillPage).groups;
                    var fillPageGroupShields = void 0;
                    for (var grUid in currFillPageGroups) {
                        if (currFillPageGroups[grUid].id === selGroup.id) {
                            fillPageGroupShields = getGroupShieldsArray(currFillPageGroups[grUid]);
                            break;
                        }
                    }
                    if (fillPageGroupShields && fillPageGroupShields[selShieldGroupIndex]) {
                        fillShields_1.push(fillPageGroupShields[selShieldGroupIndex]);
                    }
                }
                break;
            }
        }
        var slaveExists_1 = ((_k = (_j = state === null || state === void 0 ? void 0 : state.core) === null || _j === void 0 ? void 0 : _j.selWizard) === null || _k === void 0 ? void 0 : _k.application_type) === 'CABLE_FLAG' && ((_m = (_l = state === null || state === void 0 ? void 0 : state.core) === null || _l === void 0 ? void 0 : _l.selWizard) === null || _m === void 0 ? void 0 : _m.data) && ((_q = (_p = (_o = state === null || state === void 0 ? void 0 : state.core) === null || _o === void 0 ? void 0 : _o.selWizard) === null || _p === void 0 ? void 0 : _p.data) === null || _q === void 0 ? void 0 : _q.isCableFlagSync);
        fillShields_1.forEach(function (fillShield, fillShieldIndex) {
            var _a, _b, _c, _d, _e, _f;
            var fillShieldPage = getAllLayers(fillShield.id, pagesData.store).page;
            if (fillShields_1[0].id !== fillShield.id) {
                if (fillShieldPage && ((_b = (_a = state === null || state === void 0 ? void 0 : state.core) === null || _a === void 0 ? void 0 : _a.selWizard) === null || _b === void 0 ? void 0 : _b.application_type) === 'CABLE_FLAG' && ((_d = (_c = state === null || state === void 0 ? void 0 : state.core) === null || _c === void 0 ? void 0 : _c.selWizard) === null || _d === void 0 ? void 0 : _d.data)) {
                    fillShieldPage.sections = clearShield(fillShieldPage, fillShield.id);
                }
                copyShieldLayout(selShield.id, fillShield.id, pagesData, { selSectionId: selSection.id, includeOtherContent: includeOtherContent }, state);
            }
            if (fillShieldPage) {
                var secToClone = getShieldSectionsArray(fillShield, fillShieldPage.sections)
                    // by 'id' - for first page,
                    // by 'sourceSectionId' - for other pages, where sections was created by 'copyShieldLayout'
                    .find(function (sec) { return sec.id === selSection.id || sec.sourceSectionId === selSection.id; });
                if (secToClone) {
                    var secToInsert = Section.fromDict(secToClone).clone();
                    if ((_e = list[fillShieldIndex]) === null || _e === void 0 ? void 0 : _e.content.text) {
                        secToInsert.setContentText(list[fillShieldIndex].content.text);
                    }
                    else if ((_f = list[fillShieldIndex]) === null || _f === void 0 ? void 0 : _f.content.symbol) {
                        secToInsert.setContentGlyph(list[fillShieldIndex].content.symbol);
                    }
                    // else {
                    //*** need to copy full section content. it's already done by copyShieldLayout
                    // }
                    if (additOptions.afterSectionUpdateContent) {
                        additOptions.afterSectionUpdateContent(secToInsert, list[fillShieldIndex]);
                    }
                    fillShieldPage.sections[secToInsert.id] = secToInsert.toDict();
                    pagesData.lastElement.section = fillShieldPage.sections[secToInsert.id];
                    pagesData.lastElement.shield = fillShield;
                    if (slaveExists_1) {
                        syncShieldLayout(fillShield.id, pagesData, state);
                    }
                }
            }
        });
    }
    return pagesData;
};
var checkExistingPageByIndex = function (pageIndex, pagesData, options, state) {
    var _a;
    var matfile = options.matfile, pageLength = options.pageLength;
    // create if not exist
    if (pagesData.order.length <= pageIndex) {
        var generatedPage = createNewPage();
        var page = matfile.type === MATFILE_ENDLESS_TYPE ? __assign({}, applyPageWidthToPage(pageLength, generatedPage, (_a = state === null || state === void 0 ? void 0 : state.core) === null || _a === void 0 ? void 0 : _a.selWizard)) : generatedPage;
        pagesData.store[page.uid] = page;
        pagesData.order.push(page.uid);
    }
    if (pagesData.order.length <= pageIndex) {
        checkExistingPageByIndex(pageIndex, pagesData, options, state);
    }
    var addedPageUid = pagesData.order[pageIndex];
    return pagesData.store[addedPageUid];
};
var copyShieldLayout = function (sourceShieldId, targetShieldId, pagesData, additOptions, state) {
    var includeOtherContent = additOptions.includeOtherContent, selSectionId = additOptions.selSectionId;
    var _a = getAllLayers(sourceShieldId, pagesData.store), sourcePage = _a.page, sourceShield = _a.shield;
    if (sourceShield && sourcePage) {
        var sourcePageSections = sourcePage.sections;
        var _b = getAllLayers(targetShieldId, pagesData.store), targetShield_1 = _b.shield, targetPage_1 = _b.page;
        if (targetPage_1 && targetShield_1) {
            getShieldSectionsArray(sourceShield, sourcePageSections).forEach(function (sourceSection) {
                var secCopy = copySectionToShield(sourceSection, targetShield_1, pagesData.store);
                if (secCopy) {
                    if (!includeOtherContent && selSectionId && selSectionId !== secCopy.sourceSectionId) {
                        return;
                    }
                    targetPage_1.sections[secCopy.id] = secCopy;
                }
            });
        }
    }
};
var syncShieldLayout = function (sourceShieldId, pagesData, state) {
    var _a = getAllLayers(sourceShieldId, pagesData.store), sourcePage = _a.page, selGroup = _a.group, sourceShield = _a.shield;
    if (sourceShield && sourcePage && selGroup) {
        var sourcePageSections = sourcePage.sections;
        var targetShield_2 = Object.values(selGroup.shields).find(function (el) { return el.primitiveProps.x !== sourceShield.primitiveProps.x; });
        if (targetShield_2 && (sourcePage === null || sourcePage === void 0 ? void 0 : sourcePage.sections)) {
            sourcePage.sections = clearShield(sourcePage, targetShield_2.id);
            getShieldSectionsArray(sourceShield, sourcePageSections).forEach(function (sourceSection) {
                var _a, _b, _c;
                // here we need to handle the slave angle
                var secCopy = copySectionToShield(sourceSection, targetShield_2, pagesData.store, ((_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.core) === null || _a === void 0 ? void 0 : _a.selWizard) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.slaveAngle) > 0);
                if (secCopy) {
                    sourcePage.sections[secCopy.id] = secCopy;
                }
            });
        }
    }
};
